import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { inject } from "@angular/core/testing";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { SM_CONSTANTS } from "../../constants/sm-constants";
import { ApiService } from "src/app/providers/api.service";
import { Subscription } from "rxjs";
import { LoaderServiceService } from "src/app/providers/loader-service.service";

@Component({
  selector: "sm-employee-assign-for-service",
  templateUrl: "./employee-assign-for-service.component.html",
  styleUrls: ["./employee-assign-for-service.component.scss"],
})
export class EmployeeAssignForServiceComponent implements OnInit,OnDestroy {
  employeeList: any = [];
  selectedEmployees: any = [];
  _apiSubscription: Subscription;
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentdata: any,
    private _apiService: ApiService,
    private loader: LoaderServiceService,
    private activemodal: MatDialogRef<EmployeeAssignForServiceComponent>
  ) {
    this._apiSubscription = this._apiService.apiResult.subscribe((res) => {
      console.log("Response", res);

      if (res.responseType === SM_CONSTANTS.GET_EMPLOYEE_LIST_RESULT) {
        this.employeeList = [];
        if (res.result) {
          res.result.forEach((element: any) => {
            if (element.isExEmployee != 1) {
              element.toShow = true;
              this.employeeList.push(element);
            }
          });

        
          this.modalData.data.completed_by.forEach((element: any) => {
            this.selectEmployee(element);
          });
          // this.loader.showLoader = false
        }
      }
    });
  }
  modalData:any = null
  ngOnInit(): void {
    this.modalData = JSON.parse(JSON.stringify(this.parentdata))
    console.log(this.modalData);
    // this.loader.showLoader = true
    this._apiService.getEmployeeList(
      localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_HASH)
    );
  }

  selectEmployee(employee: any) {
    const index = this.employeeList.findIndex(
      (x: any) => x.employeeHashId == employee.completed_by_hash
    );
    this.employeeList[index].toShow = false;
    // if(index != -1){
    //   this.selectedEmployees.push(employee)
    // }
  }
  checkEmployeeListVisibility(){
    const index = this.employeeList.findIndex((employee:any) => employee.toShow == true)
    if(index != -1){
      return true
    }
    return false
  }
  onclickEmployeeName(employee:any, index:any){
    employee.toShow = false
    this.modalData.data.total_completed_services_qty++;

    let service_cost;
    if (this.modalData.serviceType == "0") {
      if (this.modalData.data.discountStatus == 1) {
        service_cost = this.modalData.data.homeDiscountedPrice;
        // this.newbookingData.price += this.parentdata.data.homeDiscountedPrice
      } else if (this.modalData.data.discountStatus == 0) {
        service_cost = this.modalData.data.home_rate;
        // this.newbookingData.price += this.parentdata.data.home_rate
      }
    } else if (this.modalData.serviceType == "1") {
      if (this.modalData.data.discountStatus == 1) {
        service_cost = this.modalData.data.shopDiscountedPrice;
        // this.newbookingData.price += this.parentdata.data.shopDiscountedPrice
      } else if (this.modalData.data.discountStatus == 0) {
        service_cost = this.modalData.data.shop_rate;
        // this.newbookingData.price += this.parentdata.data.shop_rate
      }
    }
    this.modalData.data.completed_by.push(
      {
        "cost": service_cost,
        "employee_name": employee.name,
        "completed_by_hash": employee.employeeHashId,
        "competed_services_qty": 1
    }
    )
    
  }

  decreaseEmployeeService(item: any, index: any) {
    if(item.competed_services_qty == 1){
      this.modalData.data.total_completed_services_qty--;
      item.competed_services_qty--;
      this.modalData.data.completed_by.splice(index,1)
      const index1 = this.employeeList.findIndex(
        (x:any) => x.employeeHashId == item.completed_by_hash 
        
      )
      this.employeeList[index1].toShow = true;
      
    }
    else{
      this.modalData.data.total_completed_services_qty--;
      item.competed_services_qty--;
  
      let service_cost;
      if (this.modalData.serviceType == "0") {
        if (this.modalData.data.discountStatus == 1) {
          service_cost = this.modalData.data.homeDiscountedPrice;
          // this.newbookingData.price += this.parentdata.data.homeDiscountedPrice
        } else if (this.modalData.data.discountStatus == 0) {
          service_cost = this.modalData.data.home_rate;
          // this.newbookingData.price += this.parentdata.data.home_rate
        }
      } else if (this.modalData.serviceType == "1") {
        if (this.modalData.data.discountStatus == 1) {
          service_cost = this.modalData.data.shopDiscountedPrice;
          // this.newbookingData.price += this.parentdata.data.shopDiscountedPrice
        } else if (this.modalData.data.discountStatus == 0) {
          service_cost = this.modalData.data.shop_rate;
          // this.newbookingData.price += this.parentdata.data.shop_rate
        }
      }
  
      item.cost -= service_cost;
    }
  }
  increaseEmployeeService(item: any, index: any) {
    this.modalData.data.total_completed_services_qty++;
    item.competed_services_qty++;

    let service_cost;
    if (this.modalData.serviceType == "0") {
      if (this.modalData.data.discountStatus == 1) {
        service_cost = this.modalData.data.homeDiscountedPrice;
        // this.newbookingData.price += this.modalData.data.homeDiscountedPrice
      } else if (this.modalData.data.discountStatus == 0) {
        service_cost = this.modalData.data.home_rate;
        // this.newbookingData.price += this.modalData.data.home_rate
      }
    } else if (this.modalData.serviceType == "1") {
      if (this.modalData.data.discountStatus == 1) {
        service_cost = this.modalData.data.shopDiscountedPrice;
        // this.newbookingData.price += this.modalData.data.shopDiscountedPrice
      } else if (this.modalData.data.discountStatus == 0) {
        service_cost = this.modalData.data.shop_rate;
        // this.newbookingData.price += this.modalData.data.shop_rate
      }
    }

    item.cost += service_cost;
  }

  saveAssignment(){
    // console.log(this.modalData.data);
    
    this.activemodal.close(this.modalData.data)
  }

  removeEmployeeAssignment(employee:any, index:any){
    const index1 = this.employeeList.findIndex(
      (x:any) => x.employeeHashId == employee.completed_by_hash 
      
    )
    this.employeeList[index1].toShow = true;
    this.modalData.data.completed_by.splice(index,1)
    this.modalData.data.total_completed_services_qty -= employee.competed_services_qty;
  }





  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
    this.modalData = null
  }
}
